import { useQuery } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';

import { listCompanies, listMembers } from '../api/lookups.client.js';
import { listTaskActivities } from '../api/tasks.client.js';

export function useMembers() {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';
  return useQuery({
    queryKey: ['members', workspaceId],
    queryFn: () => listMembers(),
    enabled: scope !== null,
    staleTime: 60_000,
  });
}

export function useCompanies() {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';
  return useQuery({
    queryKey: ['companies', workspaceId],
    queryFn: () => listCompanies(),
    enabled: scope !== null,
    staleTime: 60_000,
  });
}

export function useTaskActivities(taskId: string | null) {
  const scope = useCurrentScope();
  const workspaceId = scope?.workspaceId ?? 'anonymous';
  return useQuery({
    queryKey: ['task-activities', workspaceId, taskId ?? 'none'],
    queryFn: () => listTaskActivities(taskId as string),
    enabled: scope !== null && taskId !== null,
  });
}
